import React, { useEffect, useState } from 'react'
import { FieldComponent } from 'components/Shared/FieldComponent'
import Sections from 'components/Order/sections'
import { FormColumn } from 'components/Shared/CrudComponents'
import styles from 'components/Order/OrderForms/OrderForm/ResponsiblePersonsForm/ResponsiblePersonsForm.module.css'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import { useErrorHandling } from 'context/errorHandling'
import { fetchForwarders } from 'services'
import { useTranslation } from 'react-i18next'
import { useAuth, ORDER_ADDITIONAL_INFO_WRITE, ORDER_ADDITIONAL_INFO_READ } from 'context/auth'
import {CheckboxField} from "../../../../Shared/CheckboxField";

export function OrderInfoForm () {
  const { t } = useTranslation()
  const [forwarders, setForwarders] = useState(null)

  const { handleError } = useErrorHandling()
  const { hasAnyPrivileges } = useAuth()

  function getOptionLabel (user) {
    return `${user.firstName} ${user.lastName}`
  }

  useEffect(() => {
    fetchForwarders()
      .then(forwarders => {
        setForwarders(forwarders)
      })
      .catch(handleError)
  }, [handleError])

  return <FormColumn section={Sections.OrderInfo}
                     disabled={!hasAnyPrivileges([ORDER_ADDITIONAL_INFO_WRITE])}
                     visible={hasAnyPrivileges([ORDER_ADDITIONAL_INFO_READ])}>
    <FieldComponent fieldName={'comment'} label={'form.order.orderInfo.visibleInSystemComment'} multiline/>
    <FieldComponent fieldName={'printComment'} label={'form.order.orderInfo.visibleInPrintComment'} multiline/>
    <StyledShareholderSelectField t={t} forwarders={forwarders} getOptionLabel={getOptionLabel}/>
    <CheckboxField name={'highValue'} label={'form.order.orderInfo.highValue'} multiline/>
  </FormColumn>
}

function StyledShareholderSelectField ({ t, forwarders, getOptionLabel, disabled }) {
  return <div className={styles.select}>
    {forwarders && <ControlledSelectField
      options={forwarders}
      fieldName="shareholderId"
      label={t('form.order.orderInfo.shareholder')}
      getOptionLabel={getOptionLabel}
      disabled={disabled}
    />}
  </div>
}